import { getCachedGymId } from '../receptionist/gymContext';
import { peekCache } from './queryCache';
import { branchScopeCacheSuffix } from '../gym/branchContext';

export function gymCacheKey(suffix) {
  const gid = getCachedGymId();
  if (!gid) return null;
  return `gym:${gid}:${suffix}${branchScopeCacheSuffix()}`;
}

export function peekGymCache(suffix) {
  const key = gymCacheKey(suffix);
  if (!key) return null;
  // Try branch-scoped key first, then plain key (admin warm / legacy)
  const scoped = peekCache(key);
  if (scoped != null) return scoped;
  const gid = getCachedGymId();
  if (!gid) return null;
  return peekCache(`gym:${gid}:${suffix}`);
}
